import React from "react";

const LAB_PHOTO = "https://images.pexels.com/photos/3735747/pexels-photo-3735747.jpeg?auto=compress&cs=tinysrgb&w=1200";

const values = [
  "Atención al cliente",
  "Calidad",
  "Ética profesional",
  "Innovación",
  "Personas",
  "Cultura del deporte",
  "Variedad",
];

const pillars = [
  { title: "Precisión científica", desc: "Cada fórmula pasa por I+D, control de calidad y validación antes de su fabricación." },
  { title: "Compromiso B2B", desc: "Somos el partner detrás de tu marca: fabricación propia y para terceros, con foco 100% B2B." },
  { title: "Escalabilidad real", desc: "Desde tu primera producción hasta el volumen necesario para exportar a nuevos mercados." },
];

export default function About() {
  return (
    <section id="nosotros" className="relative py-10 md:py-14 bg-[#F8FAFC] border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 items-stretch">
          <div className="lg:col-span-5 flex flex-col">
            <div className="text-xs uppercase tracking-[0.3em] text-[#0A84E2] font-semibold mb-4">/ 01 · Quiénes somos</div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#0A1628] uppercase tracking-tighter leading-[1]">
              Ciencia aplicada
              <br />
              <span className="text-[#0A84E2]">a cada lote.</span>
            </h2>

            <div className="mt-10 flex flex-wrap gap-2">
              {values.map((v) => (
                <span key={v} data-testid={`about-value-tag-${v}`} className="text-xs font-semibold uppercase tracking-wider text-[#086AB7] bg-white border border-[#0A84E2]/30 px-3 py-1.5 rounded-full">
                  {v}
                </span>
              ))}
            </div>

            <div className="mt-8 flex-1 min-h-[240px] rounded-sm overflow-hidden border border-slate-200 shadow-lg">
              <img src={LAB_PHOTO} alt="Laboratorio Global Nutralabs" className="w-full h-full object-cover" />
            </div>
          </div>

          <div className="lg:col-span-7 space-y-6 text-slate-700 text-lg leading-relaxed">
            <p>
              Global Nutralabs nació en <span className="text-[#0A1628] font-semibold">2021, en Arganda del Rey (Madrid)</span>, con una misión clara: hacer accesible la fabricación de suplementación deportiva de calidad premium a marcas propias y de terceros. Desde nuestra planta española ayudamos a nuestros clientes B2B a lanzar y escalar productos bajo estándares <span className="text-[#0A1628] font-semibold">GMP</span>, <span className="text-[#0A1628] font-semibold">registro FDA</span> y <span className="text-[#0A1628] font-semibold">sistema de autocontrol APPCC</span>.
            </p>
            <p>
              Combinamos un equipo técnico especializado en formulación —enfocado en <span className="text-[#0A1628] font-semibold">I+D, estabilidad y validación</span> de producto— con procesos de fabricación auditados bajo normativa GMP. El resultado: fórmulas eficaces, sabores desarrollados y una producción estable a cualquier escala, con más de <span className="text-[#0A1628] font-semibold">1.000 referencias activas</span>.
            </p>

            {/* Misión */}
            <blockquote className="border-l-4 border-[#0A84E2] pl-6 py-2 text-base md:text-lg text-slate-600 italic">
              &ldquo;Nuestra misión es dar respuesta a las demandas de una sociedad que desea fomentar su calidad de vida a través del deporte y el cuidado personal. Por ello, desarrollamos productos de alta calidad y pureza a precios asequibles, que ayuden a los consumidores a complementar su dieta y mejorar su rendimiento.&rdquo;
            </blockquote>

            <div className="grid sm:grid-cols-3 gap-4 pt-4">
              {pillars.map((v, i) => (
                <div key={i} data-testid={`about-pillar-${i}`} className="corp-card rounded-sm p-5">
                  <div className="font-display font-semibold text-[#0A1628] text-base">{v.title}</div>
                  <div className="mt-2 text-sm text-slate-600 leading-relaxed">{v.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
